import React, { useState, useEffect, useRef } from "react";
import "./App.css";


function App() {

  const [message, setMessage] = useState("");
  const [chat, setChat] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(true);   // Chatbot always open
  const [paused, setPaused] = useState(false);

  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [schemes, setSchemes] = useState([]);
  const [selectedScheme, setSelectedScheme] = useState("");
  // 🌐 BASE URL FOR IIS / LOCALHOST
  const API_BASE = `${window.location.origin}/api`;
  const msgEndRef = useRef(null);

  // Detect whether text is Marathi (Devanagari script)
const isMarathi = (text) => {
  const devanagari = /[\u0900-\u097F]/; 
  return devanagari.test(text);
};

  // 🔥 AUTO GREETING — runs ONLY ON FIRST LOAD
  useEffect(() => {
    setChat([
      {
        role: "bot",
        type: "greeting",
        text:
          "👋 Welcome to MEDA Support!\n" +
          "How can I assist you today?\n\n" +
          "Please type your query below.\n" +
          "आपला प्रश्न खालील टेक्स्ट बॉक्समध्ये लिहा."
      }
    ]);
  }, []);

  // Auto-scroll
  useEffect(() => {
    if (msgEndRef.current) {
      msgEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [chat, loading]);

  // FETCH SCHEMES
  const fetchSchemes = (category) => {
    setSelectedCategory(category);
    fetch(`${API_BASE}/get_schemes?category=${encodeURIComponent(category)}`)

      .then((res) => res.json())
      .then((data) => setSchemes(data.schemes))
      .catch(console.error);
  };

// FETCH SCHEME DETAILS
// FETCH SCHEME DETAILS
const fetchSchemeDetails = (scheme) => {
  setSelectedScheme(scheme);
  setSchemes([]);

  setChat((prev) => [
    ...prev,
    { role: "user", text: `Tell me about ${scheme}` }
  ]);

  fetch(`${API_BASE}/scheme_details`, {

    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ scheme }),
  })
    .then((res) => res.json())
    .then((data) => {
      // ⭐ Show ONLY FAISS database answer
      let finalAnswer = (data.answer || "").replace(/\\n/g, "\n");

      // ⭐ Ensure footer always appears even if backend fails to return it
      if (!finalAnswer.includes("📘 Based on MEDA Database")) {
        finalAnswer += "\n\n📘 Based on MEDA Database";
      }

      typeMessage(finalAnswer);
    })
    .catch(() => {
      typeMessage("Error fetching scheme details.");
    });
};


const typeMessage = (text, onComplete) => {
  let clean = text.replace(/\\n/g, "\n").replace(/\0/g, "");
  let idx = 0;

  // Add blank bot message first
  setChat(prev => [
    ...prev,
    { role: "bot", text: "", complete: false, translated: "", translating: false }
  ]);

  const interval = setInterval(() => {
    if (idx < clean.length) {
      setChat(prev => {
        const updated = [...prev];
        updated[updated.length - 1].text = clean.slice(0, idx + 1);
        return updated;
      });
      idx++;
    } else {
      clearInterval(interval);

      // Mark this message complete
      setChat(prev => {
        const updated = [...prev];
        updated[updated.length - 1].complete = true;
        return updated;
      });

      // 🔥 Now call the callback
      if (onComplete) onComplete();
    }
  }, 15);
};


  const translateMessage = async (text, index) => {
  try {
    setChat(prev => {
      const updated = [...prev];
      updated[index].translating = true;
      return updated;
    });

    const targetLang = isMarathi(text) ? "english" : "marathi";

    const res = await fetch(`${API_BASE}/translate`, {

      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ text, target: targetLang })
    });

    const data = await res.json();

    setChat(prev => {
      const updated = [...prev];
      updated[index].translated = data.translated;
      updated[index].translating = false;
      return updated;
    });

  } catch (e) {
    alert("Translation error: " + e.message);
  }
};


  // SEND MESSAGE
  const sendMessage = async () => {
    if (!message.trim()) return;

    setCategories([]);
    setSchemes([]);
    setSelectedCategory("");
    setSelectedScheme("");

    const userMsg = message;
    setMessage("");

// Smart scheme detection
const msgLower = userMsg.toLowerCase();

// Phrases that should open the schemes menu
const schemeMenuTriggers = [
  "schemes",
  "list schemes",
  "scheme list",
  "i want to know about schemes",
  "tell me about schemes",
  "show me schemes",
  "what schemes",
  "all schemes",
  "Tell me about Scheme"
];

// If message EXACTLY matches generic scheme intent → open menu
if (schemeMenuTriggers.some(phrase => msgLower.includes(phrase))) {
  setCategories([
    "Solar Schemes",
    "Green Hydrogen Schemes",
    "PM-KUSUM Schemes",
    "New & Renewable Energy Department Schemes",
    "Energy Conservation Programme",
  ]);

  setChat((prev) => [
    ...prev,
    { role: "user", text: userMsg },
    { role: "bot", text: "Sure! Please select a category below 👇" },
  ]);
  return;
}


    setChat((prev) => [...prev, { role: "user", text: userMsg }]);
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE}/chat`, {

        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ message: userMsg }),
      });

      const data = await res.json();
typeMessage((data.answer || "").replace(/\\n/g, "\n"));
// , () => {
// //   if (!data.skip_satisfaction) {
// //     setChat(prev => [
// //       ...prev,
// //       {
// //         role: "bot",
// //         text: "Are you satisfied with this answer?",
// //         complete: true,
// //         askSatisfaction: true
// //     }
// //   ]);
// // }
// // });

    } catch {
      typeMessage("Server error. Try again.");
    }

    setLoading(false);
  };

  return (
    <>
      <div className="chat-container">

        {/* HEADER */}
        <div className="chat-header">
          <span>MEDA Support (BETA)</span>

          <button
            className="reset-btn"
        onClick={() => {
          setCategories([]);
          setSchemes([]);
          setSelectedCategory("");
          setSelectedScheme("");

          setChat([
            {
              role: "bot",
              type: "greeting",
              text:
                "👋 Welcome to MEDA Support!\n" +
                "How can I assist you today?\n\n" +
                "Please type your query below.\n" +
                "आपला प्रश्न खालील टेक्स्ट बॉक्समध्ये लिहा."
            }
          ]);
        }}
          >
            Reset
          </button>
        </div>

        {/* CHAT MESSAGES */}
        <div className="chat-messages">
          {chat.map((msg, i) => (
            <div key={i}>
              {msg.type === "greeting" ? (
                <div className="greeting-card">
                  <div className="greeting-avatar">
                    <img src="bot.png" alt="Bot" />
                  </div>
                  <div className="greeting-text">{msg.text}</div>
                </div>
              ) : msg.role === "bot" ? (
  <div className="bot-wrapper">
    <img src="bot.png" alt="Bot" />
    <div className="bot-msg">
      {/* MAIN BOT MESSAGE */}
      {msg.text}

      {/* TRANSLATE BUTTON */}
      {msg.complete && !msg.translated && !msg.translating && (
    <div
      className="translate-btn"
      onClick={() => translateMessage(msg.text, i)}
    >
      {isMarathi(msg.text) ? "Translate to English" : "Translate to Marathi"}
    </div>
      )}

      {/* TRANSLATING LOADER */}
      {msg.translating && <div className="translating">⏳ Translating...</div>}

      {/* TRANSLATED TEXT */}
      {msg.translated && (
        <div className="bot-msg translated">{msg.translated}</div>
      )}

      {/* ⭐ SATISFACTION BUTTONS (YES / NO) */}
{/* {msg.complete && msg.askSatisfaction && !msg.skip_satisfaction && (
  <div className="satisfaction-box">
    <div
      className="satisfaction-btn yes"
      onClick={() => handleSatisfaction(i, true)}
    >
      Yes
    </div>
    <div
      className="satisfaction-btn no"
      onClick={() => handleSatisfaction(i, false)}
    >
      No
    </div>
  </div>
)} */}
    </div>
  </div>
) : (
  <div className="user-wrapper">
    <div className="user-msg">{msg.text}</div>
    <img src="image.png" alt="User" />
  </div>
)}
</div>
))}

{/* BOT IS TYPING */}
{loading && (
  <div className="bot-wrapper">
    <img src="bot.png" alt="Bot" />
    <div className="bot-msg">Typing...</div>
  </div>
)}

<div ref={msgEndRef} />

        </div>

        {/* CATEGORY MENU */}
        {categories.length > 0 && !selectedCategory && (
          <div className="menu-box">
            <strong>Select Category:</strong>
            {categories.map((cat, i) => (
              <div
                key={i}
                className="scheme-bubble"
                onClick={() => fetchSchemes(cat)}
              >
                {cat}
              </div>
            ))}
          </div>
        )}



        {/* SCHEME MENU */}
        {schemes.length > 0 && !selectedScheme && (
          <div className="menu-box">
            <strong>Select Scheme:</strong>
            {schemes.map((sc, i) => (
              <div
                key={i}
                className="scheme-bubble-internal"
                onClick={() => fetchSchemeDetails(sc)}
              >
                {sc}
              </div>
            ))}

            <div
              className="back-button"
              onClick={() => {
                setSchemes([]);
                setSelectedCategory("");
              }}
            >
              ← Back
            </div>
          </div>
        )}

        {/* INPUT */}
        <div className="chat-input">
          <input
            type="text"
            value={message}
            placeholder="Type your message..."
            onChange={(e) => setMessage(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && sendMessage()}
          />
          <button onClick={sendMessage}>Send</button>
        </div>
      </div>
    </>
  );
}

export default App;
